import {useCallback, useRef, useState} from "react";
import Header from "./Header";
import Loading from "./Loading";
import {fetchSinglePresignedUrl, insertSingleManuscript, uploadManuscript} from "../service/ManuscriptService";
import {useNavigate} from "react-router-dom";

function UploadSingle() {
    const [dragOver, setDragOver] = useState(false);
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState(null);
    const [authors, setAuthors] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(false);
    const [email, setEmail] = useState(null);
    const navigate = useNavigate();

    const onDrop = useCallback((e) => {
        e.preventDefault();
        setDragOver(false);
        const f = e.dataTransfer.files?.[0];
        if (f) setFile(f);
    }, []);

    const onChooseFile = () => fileInputRef.current?.click();

    // function submitManuscript(file) {
    //     setLoading(true);
    //     setSubmitted(false);
    //     setError(false);
    //     setEmail(null);
    //     uploadManuscript(file, title, authors, true)
    //         .then(response => {
    //             if (response) {
    //                 setSubmitted(true);
    //                 setTitle(null);
    //                 setAuthors(null);
    //                 setFile(null);
    //                 if (response.email != null) {
    //                     setEmail(response.email);
    //                 }
    //             } else {
    //                 setError(true);
    //             }
    //             setLoading(false);
    //
    //         })
    //         .catch(() => {
    //             setLoading(false);
    //             setError(true);
    //         });
    //
    // }


    function submitManuscript() {
        setLoading(true);
        setSubmitted(false);
        setError(false);
        setEmail(null);
        fetchSinglePresignedUrl(true)
            .then(async (response) => {
                if (response?.presignedUrl?.url) {
                    const uploadResp = await fetch(response.presignedUrl.url, {
                        method: "PUT",
                        headers: {
                            "Content-Type": "application/pdf",
                        },
                        body: file,
                    });
                    if (!uploadResp.ok) {
                        setError(true);
                        return;
                    }

                    const key = response.presignedUrl.key
                    insertSingleManuscript(key, file.name, title, authors, true)
                        .then(response => {
                            if (response.success && response.email != null) {
                                setFile(null)
                                setEmail(response.email)
                                setSubmitted(true);
                                setTitle(null);
                                setAuthors(null);
                            } else {
                                setError(true);
                            }
                            setLoading(false);
                        })
                        .catch((e) => {
                            setError(true);
                            setLoading(false);
                        });
                } else {
                    setLoading(false);
                    setError(true);
                }
            })
            .catch((err) => {
                console.error("Upload error:", err);
                setError(true);
                setLoading(false);
            });
    }
    // function submitManuscript() {
    //     setLoading(true);
    //     setSubmitted(false);
    //     setError(false);
    //     setEmail(null);
    //     let presignedUrl = null;
    //     let user = null;
    //
    //     fetchPresignedUrl(true)
    //         .then(response => {
    //             if (response && response.presignedUrl) {
    //                 presignedUrl = response.presignedUrl;
    //                 const s3Response = fetch(presignedUrl, {
    //                     method: "PUT",
    //                     headers: {
    //                         "Content-Type": "application/pdf"
    //                     },
    //                     body: file
    //                 });
    //                 console.log(s3Response)
    //             }
    //         })
    //         .catch(() => {
    //         setLoading(false);
    //         setError(true);
    //     });
    //     setLoading(true);
    //     setSubmitted(false);
    //     setError(false);
    //     setEmail(null);

        // )
        // uploadManuscript(file, title, authors, true)
        //     .then(response => {
        //         if (response) {
        //             setSubmitted(true);
        //             setTitle(null);
        //             setAuthors(null);
        //             setFile(null);
        //             if (response.email != null) {
        //                 setEmail(response.email);
        //             }
        //         } else {
        //             setError(true);
        //         }
        //         setLoading(false);
        //
        //     })
        //     .catch(() => {
        //         setLoading(false);
        //         setError(true);
        //     });
    // }

    return (
        <div>
            <Header page="home"/>
            {loading ?
                <Loading/>
                :
                <div className="body">
                    <div className="heading">Upload Manuscript</div>
                    {error ?
                        <div className={"score-submitted-text"} style={{border: '2px solid red'}}>There was an error
                            uploading your file. Please try again.
                        </div>
                        :
                        submitted ?
                            <div className={"score-submitted-text"} style={{border: '2px solid green'}}>Your manuscript
                                has been submitted! We will send an email to {email} when processing is complete. You
                                may check the status of all of your submissions on the submissions page.
                            </div>
                            :
                            null
                    }
                    <div className="upload-card">
                        <br/>
                        <div
                            className={`dropzone ${dragOver ? "is-drag" : ""}`}
                            onDragOver={(e) => {
                                e.preventDefault();
                                setDragOver(true);
                            }}
                            onDragLeave={() => setDragOver(false)}
                            onDrop={onDrop}
                            onClick={onChooseFile}
                            role="button"
                            tabIndex={0}
                        >
                            {/* upload arrow icon */}
                            <svg width="48" height="48" viewBox="0 0 24 24" aria-hidden="true">
                                <path
                                    d="M12 3l4.5 4.5-.71.7L12.5 5.62V16h-1V5.62L8.2 8.2l-.7-.7L12 3zM5 18h14v1H5z"
                                    fill="#666"
                                />
                            </svg>
                            <div className="drop-label">
                                {file ? file.name : "Drag and drop file"}
                            </div>
                            <div className="drop-label-mobile">
                                {file ? file.name : "Upload file"}
                            </div>
                            <input ref={fileInputRef} type="file" accept="application/pdf" hidden
                                   onChange={(e) => setFile(e.target.files?.[0] || null)}/>
                        </div>

                        <button className="choose-btn" type="button" onClick={onChooseFile}>
                            Choose PDF File
                        </button>

                        <label className="field">
                            <span>Title</span>
                            <input type="text" placeholder="" onChange={(e) => setTitle(e.target.value)}/>
                        </label>

                        <label className="field">
                            <span>Author(s)</span>
                            <input type="text" placeholder="" onChange={(e) => setAuthors(e.target.value)}/>
                        </label>

                        {/*<button className="upload-btn" type="button" disabled={!file || !title || !authors}*/}
                        <button className="upload-btn" type="button" disabled={!file}
                                onClick={() => submitManuscript(file)}>
                            Upload
                        </button>
                        <button onClick={() => navigate("/")} className={"submit fade-in margin-top-1rem"}
                        >Home</button>
                    </div>
                </div>
            }
        </div>
    );
}

export default UploadSingle;
